// This function allow to reference chunks
__webpack_require__.u = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "js/" + ({445: "actioncable",745: "chartjs",}[chunkId] || chunkId) + "-" + {445: "991574591f71fea9",745: "92b7d52b8d896f94",813: "b4e72ce834dc586c",}[chunkId] + ".chunk.js"
}